import CryptoJS, { HmacSHA256 } from "crypto-js";
import { Constants } from "utils";

import encHex from "crypto-js/enc-hex";

// Helper functions to Base64URL encode/decode
function base64UrlEncode(str: string): string {
  return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(str))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

function base64UrlDecode(str: string): string {
  str = str.replace(/-/g, "+").replace(/_/g, "/");
  while (str.length % 4 !== 0) {
    str += "=";
  }
  return CryptoJS.enc.Base64.parse(str).toString(CryptoJS.enc.Utf8);
}

export function encrypt<T>(payload: T): string {
  const plaintext = JSON.stringify(payload);
  const ciphertext = CryptoJS.AES.encrypt(plaintext, Constants.TWO_WAY_SECRET).toString();
  return base64UrlEncode(ciphertext);
}

export function decrypt(encrypted: string): any {
  const ciphertext = base64UrlDecode(encrypted);
  const bytes = CryptoJS.AES.decrypt(ciphertext, Constants.TWO_WAY_SECRET);
  const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedText);
}


export function hash(password: string): string {
  return HmacSHA256(password, Constants.HASHING_SECRET).toString(encHex);
}